// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RedditSquareFilledSvg from "@fishx/icons-svg/es/asn/RedditSquareFilled";
import FishxIcon from '../components/FishxIcon';

var RedditSquareFilled = function RedditSquareFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: RedditSquareFilledSvg
  }));
};

RedditSquareFilled.displayName = 'RedditSquareFilled';
export default React.forwardRef(RedditSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/RedditSquareFilled.js
// module id = 3987
// module chunks = 0